import { useQuery } from '@tanstack/react-query';
import { useCanCheck } from '@/ability/helpers';
import { getRoles } from '@services/rbac.service';

export const ROLES_QUERY_KEY = ['rbac', 'roles'];

export const ROLES_VIEW_ABILITY = 'saas.roles.view';

/**
 * RBAC roles list. Must be permission-gated: without `saas.roles.view` backend returns 403.
 * @param {{ enabled?: boolean }} [options]
 */
export const useRoles = (options = {}) => {
    const can = useCanCheck();
    const canView = can(ROLES_VIEW_ABILITY);
    const enabled = (options.enabled ?? true) && canView;

    const query = useQuery({
        queryKey: ROLES_QUERY_KEY,
        queryFn: getRoles,
        enabled,
    });

    return { ...query, canView };
};
